// removed by extract-text-webpack-plugin
module.exports = {"badge":"Badge__badge","green":"Badge__green","black":"Badge__black","red":"Badge__red","orange":"Badge__orange","text":"Badge__text"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Badge/Badge.css
// module id = 482
// module chunks = 8